import { render, staticRenderFns } from "./workload.vue?vue&type=template&id=25c8ee18&scoped=true"
import script from "./workload.vue?vue&type=script&lang=js"
export * from "./workload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8ee18",
  null
  
)

export default component.exports